/**
 * UltraWide Streaming: custom ratios [QVI]
 *
 * Declares one web-accessible-resource — `img/times-solid.svg` — with no
 * `use_dynamic_url`, but matched only to a fixed list of streaming-service origins
 * (Netflix, Apple, Disney+, Max/HBO Max, Peacock, Paramount+, Hulu, Prime Video /
 * Amazon). It is not exposed to arbitrary pages, so a fetch from elsewhere fails at the
 * network layer and proves nothing.
 *
 * From any of those streaming origins the static SVG resolves whenever the extension is
 * installed, making it a conclusive per-origin signal.
 *
 * Manifest verified against version 1.0.78.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ofkcbakkpjefjndcmbkokadbmmaimnlp';

export const ultrawideStreaming: ExtensionDefinition = {
  id: ID,
  name: 'UltraWide Streaming: custom ratios [QVI]',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  requiredOrigin: 'https://www.netflix.com',
  notes:
    'One static WAR (img/times-solid.svg) scoped to a list of streaming origins ' +
    '(Netflix, Disney+, Hulu, Prime Video, etc.), so only those sites can detect it. ' +
    'No dynamic URL.',
  signals: [
    {
      id: 'war-times-solid-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch img/times-solid.svg — the overlay close icon, exposed only to the ' +
        'supported streaming origins. Resolves at a fixed URL when installed.',
      weight: 1,
      run: () => probeFetch(ID, 'img/times-solid.svg'),
    },
  ],
};
